import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CheckboxListItem } from './model/checkbox-list-item.model';
import { Router } from '@angular/router';
// tslint:disable: no-output-on-prefix
@Component({
  selector: 'lps-checkbox-list',
  templateUrl: './checkbox-list.component.html',
  styleUrls: ['./checkbox-list.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxListComponent),
      multi: true,
    }
  ],
})
export class CheckboxListComponent implements ControlValueAccessor {

  @Input() options: CheckboxListItem[] = [];
  @Input() disabled = false;
  @Input() groupName: string;
  @Input() showGroupName = true;
  @Input() canSelectAll = true;

  @Output() onSelect = new EventEmitter();
  @Output() onSelectAll = new EventEmitter();
  @Output() onDeselect  = new EventEmitter();

  value;
  allSelected = false;
  checkedList: any;

  indexableFilters = {
    academia: true,
    churrasqueira: true,
    piscina: true
  };

  constructor(private router: Router) {}

  set internalValue(items: any[]) {
    this.value = items;
    this.onChange(items);
    this.onTouched();
  }

  toggle() {
    this.allSelected = !this.allSelected;

    if (this.allSelected) {
      this.onSelectAll.emit(this.groupName);
    }

    this.options.forEach((o) => {
      o.checked = this.allSelected;
    });

    this.internalValue = this.allSelected
      ? this.options.map(s => s.value)
      : [];

  }

  select(item: CheckboxListItem, checked: boolean) {
    if (!this.disabled) {
      item.checked = checked;
      if (item.checked) {
        this.onSelect.emit({item, groupName: this.groupName});
      } else {
        this.onDeselect.emit({item, groupName: this.groupName});
      }
      this.writeValue();
      this.getCheckedItemList();
    }
  }

  getCheckedItemList() {
    this.checkedList = [];
    for (const each of this.options) {
      if (each.checked) {
        this.checkedList.push(this.options);
      }
      this.allSelected = this.checkedList.length === this.options.length;
    }
  }

  onChange = (value: any[]) => {
  }

  onTouched = () => {
  }

  isIndexableFilter(filter: string) {
    return this.indexableFilters[filter] || false;
  }

  registerOnChange(fn: (value: any[]) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(value?: any[]): void {
    if (value) {
      this.internalValue = value;
      this.options.forEach((o) => {
        o.checked = value.some(v => o.value === v);
      });
      if (value.length < 1) {
        this.allSelected = false;
      }
      if (value.length === this.options.length) {
        this.allSelected = true;
      }
    } else {
      this.internalValue = this.options
        .filter(o => o.checked)
        .map(o => o.value);
    }
  }

  setHref(option) {
    const url = this.router.url.replace(/\?(.*)/gi, '');
    if (url.includes(option.value)) {
      return url;
    }
    return `${this.router.url.replace(/\?(.*)/gi, '').replace(/\/comodidade(.*)/gi, '')}/comodidade/com-${option.value}`;
  }
}
